import React, { useState } from 'react';
import { Box } from '../../../base';
import { IInterviewQuestion } from '../../../common';
import NoInterviewQuestions from './NoInterviewQuestions';
import InterviewQuestionItem from './InterviewQuestionItem';

interface Props {
    interviewQuestions: IInterviewQuestion[];
}

const InterviewQuestions = (props: Props) => {
    const { interviewQuestions } = props;
    const [expanded, setExpanded] = useState<number>(-1);

    const handleChange =
        (panel: number) =>
        (_event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : -1);
        };

    return (
        <Box>
            {interviewQuestions?.length > 0 ? (
                interviewQuestions.map((question, index) => (
                    <InterviewQuestionItem
                        key={question.id}
                        question={question}
                        index={index}
                        expanded={expanded}
                        onChange={handleChange}
                    />
                ))
            ) : (
                <NoInterviewQuestions />
            )}
        </Box>
    );
};

export default InterviewQuestions;
